























































import VueOptions from '@utils/VueOptions'
import PricingModel from '@services/PricingModel'
import AudienceListingThumbnail from '@ui/cards/AudienceListingThumbnail'
import LoadingIndicator from '@/components/LoadingIndicator'
import FeedCardCenter from '@ui/Campaign/pipeline/EventFeed/FeedCardCenter'
import ActivationPlanInCartWrapper from '@ui/Campaign/pipeline/EventFeed/activation/ActivationPlanInCartWrapper'

settings =
  name: 'ShoppingCartItemCard'

  resources:
    activation_plan:
      resourceName: 'activation_plan'
      slug: 'campaigns/:campaignId/activation_plans/:activationPlanId'
      fetch: false

    campaign:
      resourceName: 'campaign'
      slug: 'campaigns/:campaignId'
      fetch: false

  vue:
    props: ['item', 'actions']

    components: {
      AudienceListingThumbnail,
      LoadingIndicator,
      FeedCardCenter,
      ActivationPlanInCartWrapper,
    }

    computed:
      activationPlanId: -> "#{@$route.params.campaignId}:#{@audienceListing.id}:#{@segment}"

      audienceListing: ->
        @audienceListingForLineItem(@item)

      segment: ->
        @item.space_name.split(':')[1]

      extraTypes: -> ['assembly', 'promo', 'serve_cold']

      isDiscounted: -> @totalPriceInDollars isnt @totalOriginalPriceInDollars
      totalPriceInDollars: ->
        @item.total_price_in_dollars
      totalOriginalPriceInDollars: ->
        @item.total_original_price_in_dollars

      showRefreshCart: ->
        return false if not @campaign
        dayjs(@campaign.updated_at).isAfter(@item.updated_at)

      actionsForActivationInCart: ->
        editActivationPlan: @editActivationPlan

      showIndicators: ->
        @audienceListing.special_terms?

      superNotes: ->
        @audienceListing.super_notes.map((item) -> "- #{item.note}").join('</br>')

    methods:
      audienceListingForLineItem: (lineItem)-> @ctxAudienceListing lineItem
      eventForLineItem: (lineItem)-> @ctxEvent lineItem
      spaceFor: (lineItem) -> @eventForLineItem(lineItem)?.spaces?[lineItem.space_name] || {}
      spaceTypeFor: (lineItem) -> @spaceFor(lineItem)?.type

      hiNavigateToAudienceListingDetails: ->
        { campaignId, tab } = @$route.params
        listingId = @audienceListing.id
        params = { campaignId, tab, listingId }
        query = { segment: @segment }
        @$router.push { name: 'CampaignCheckoutListingShow', params, query }

      hiRefreshCartListingTrigger: ->
        @actions.refreshCartListingTrigger @item, @audienceListing, @segment

      editActivationPlan: ->
        params =
          listingId: @audienceListing.id
          campaignId: @$route.params.campaignId
        query =
          segment: @segment
        @$router.push { name: 'CampaignCheckoutListingEdit', params, query }

export default VueOptions.vue settings
